import { createApi } from '@reduxjs/toolkit/query/react';
import {
  ApiErrorStatusCode,
  axiosBaseQuery,
  setupAxiosInstance,
} from 'lib-shared-auth';

import {
  forbiddenErrorHandler,
  unauthorizedErrorHandler,
} from 'app/utils/apiErrorHandlers';

import { verifyPermissions } from './utils/verifyPermissions';

export const extraResponseHandlers = [
  {
    errorCode: ApiErrorStatusCode.Forbidden,
    handler: verifyPermissions,
  },
];

export const axiosInstance = setupAxiosInstance([
  forbiddenErrorHandler,
  unauthorizedErrorHandler,
]);

// Setup RTK Query
const API_REDUCER_PATH = 'api';
/**
 * Initialize an empty api service that will be injected with endpoints later as
 * needed.
 *
 * We should only have one API slice per base URL that we communicate with. This
 * essentially creates a single API slice where separate endpoint definitions
 * can be injected from their respective folders.
 *
 * This also allows to effectively take advantage of automated re-fetching by
 * defining tag relationships across endpoints.
 *
 * Ref: https://redux-toolkit.js.org/rtk-query/api/createApi
 */
export const api = createApi({
  reducerPath: API_REDUCER_PATH,
  baseQuery: axiosBaseQuery(axiosInstance),
  endpoints: () => ({}),
});
